// extracted by mini-css-extract-plugin
export default {"eventCard":"dMX57VtDeT"};